import { create } from 'zustand'

interface UserState {
  isIdle?: boolean
  setIsIdle: (isIdle: boolean) => void
  hasVisitedHomepage: boolean
  setHasVisitedHomepage: (hasVisitedHomepage: boolean) => void
  hasAcknowledgedRedemptionToast: boolean
  setHasAcknowledgedRedemptionToast: () => void
}

const useUserStore = create<UserState>(set => ({
  hasAcknowledgedRedemptionModal: false,
  hasAcknowledgedRedemptionModalInSession: false,
  hasAcknowledgedRedemptionToast: false,
  hasVisitedHomepage: false,
  isIdle: false,
  setHasAcknowledgedRedemptionToast: () => {
    if (typeof window !== 'undefined') {
      sessionStorage.setItem('hasAcknowledgedRedemptionToast', 'true')
    }

    set({ hasAcknowledgedRedemptionToast: true })
  },
  setHasVisitedHomepage: (hasVisitedHomepage: boolean) => set({ hasVisitedHomepage }),
  setIsIdle: (isIdle: boolean) => set({ isIdle }),
}))

export default useUserStore
